import { render, staticRenderFns } from "./shzsk.vue?vue&type=template&id=624c428b&scoped=true&"
import script from "./shzsk.vue?vue&type=script&lang=js&"
export * from "./shzsk.vue?vue&type=script&lang=js&"
import style0 from "./shzsk.vue?vue&type=style&index=0&id=624c428b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c428b",
  null
  
)

export default component.exports